import React from "react";
import MainFeatureTab from "./MainFeatureTab";
import "./mainfeature.css";

const MainFeature = () => {
  const tabsList = [
    {
      label: "First",

      content: (
        <div>
          <p>First tab content</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
            cupiditate deserunt eos maiores maxime molestiae odit vitae!
          </p>
        </div>
      ),
    },
    {
      label: "Second",
      content: (
        <div>
          <p>Second tab content</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
            cupiditate deserunt eos maiores maxime molestiae odit vitae!
          </p>
        </div>
      ),
    },
    {
      label: "Third",
      content: (
        <div>
          <p>Third tab content</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
            cupiditate deserunt eos maiores maxime molestiae odit vitae!
          </p>
        </div>
      ),
    },
    {
      label: "Fourth",
      content: (
        <div>
          <p>Fourth tab content</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
            cupiditate deserunt eos maiores maxime molestiae odit vitae!
          </p>
        </div>
      ),
    },
    {
      label: "Fifth",
      content: (
        <div>
          <p>Fifth tab content</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
            cupiditate deserunt eos maiores maxime molestiae odit vitae!
          </p>
        </div>
      ),
    },
    {
      label: "Sixth",
      content: (
        <div>
          <p>Sixth tab content</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
            cupiditate deserunt eos maiores maxime molestiae odit vitae!
          </p>
        </div>
      ),
    },
    {
      label: "Seventh",
      content: (
        <div>
          <p>Seventh tab content</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
            cupiditate deserunt eos maiores maxime molestiae odit vitae!
          </p>
        </div>
      ),
    },
  ];

  return (
    <div className="container">
      <h2> Our Features</h2>
      <MainFeatureTab isVertical tabsList={tabsList} />
    </div>
  );
};

export default MainFeature;
